import * as React from 'react';
import { observer } from "mobx-react";
import { useCurrentBreakPoint } from 'telia-front-react/helper';
import { useStores } from "@stores/RootStore";

import DisturbanceClient from '@disturbance/DisturbanceClient';
import DisturbanceEmployee from '@disturbance/DisturbanceEmployee';

const Disturbance = (): React.ReactElement => {
  const currentBreak = useCurrentBreakPoint();
  const isMobile = ['xs', 'sm', 'md'].includes(currentBreak);
  const {
    ssoStore: { isDealer }
  } = useStores();

  if (isDealer) {
    return <DisturbanceEmployee isMobile={isMobile} />;
  }

  return <DisturbanceClient isMobile={isMobile} />;
}

export default observer(Disturbance);
